// extracted by mini-css-extract-plugin
export var link = "Social-module--link--43806";
export var root = "Social-module--root--c3709";